export const CollectionNames = {
  Notifications: 'notifications',
}
